import React from "react";
import EntityEmptyPage from "components/Records/NewRecordPages/EntityEmptyPage";
import AddEventsPopup from "./AddEventsPopup";


interface EventsEmptyPageProps {
  onEventsCreated?: (newEvents: any) => void;
}


export default function EventsEmptyPage({
  onEventsCreated,
}: EventsEmptyPageProps) {
  return (
    <EntityEmptyPage
      title="Events"
      colorKey="interactions"
      AddPopupComponent={AddEventsPopup}
      onEntityCreated={onEventsCreated}
      items={[
        {
          id: "select",
          type: "text",
          text: "Select an Event",
          direction: "left",
        },
        {
          id: "create",
          type: "button",
          label: "Create New Event",
          openPopup: true, 
        },
        {
          id: "send",
          type: "text",
          text: "Log Event Attendance",
          direction: "right",
        },
        {
          id: "details",
          type: "text",
          text: "View Event History",
          direction: "down",
        },
      ]}
    />
  );
}
